import React, { useState, useEffect } from "react";
import { FaSearch, FaBell, FaBook, FaUserCircle, FaChartLine, FaList, FaCog, FaSignOutAlt, FaUser, FaCogs } from "react-icons/fa";
import { useNavigate, useLocation, Link } from 'react-router-dom';


const Notification = () => {
  
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([
    { id: 1, message: "Welcome to eBrary.guru. Explore the treasure of knowledge.", read: false }
  ]);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const unreadCount = notifications.filter((n) => !n.read).length;



  return (
    <div className="relative">
    <button onClick={() => setNotificationOpen(!notificationOpen)} className="relative">
      <FaBell size={24} />
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-2 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded-full">
          {unreadCount}
        </span>
      )}
    </button>
    {notificationOpen && (
      <div className="absolute right-0 mt-2 w-64 bg-white border border-gray-300 rounded-lg shadow-lg z-50">
        <ul className="py-2 text-gray-900">
          {notifications.length > 0 ? (
            notifications.map((notif) => (
              <li key={notif.id} className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                {notif.message}
              </li>
            ))
          ) : (
            <li className="px-4 py-2 text-gray-500">No new notifications</li>
          )}
        </ul>
      </div>
    )}
  </div>
  );
};

export default Notification;
